import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
//全局注册字体
import "@/text/text.css";
import './assets/iconfont/iconfont.css'
import store from './store/index';


import axios from 'axios'
Vue.prototype.$axios = axios

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import kmb from './utils/kmb.js'

Vue.prototype.kmb = kmb;

import { formatDate, dateTypeFormat, setNumberColor, formatNum, Decimals } from './utils/utils.js'

Vue.prototype.formatDate = formatDate;
Vue.prototype.dateTypeFormat = dateTypeFormat;
Vue.prototype.setNumberColor = setNumberColor;
Vue.prototype.formatNum = formatNum;
Vue.prototype.Decimals = Decimals;

//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})


Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.directive('focus', {
  inserted: function (el) {
    el.querySelector('input').focus();
  }
});
Vue.prototype.$EventBus = new Vue()

// 跳转后返回顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js